import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from './services/firebase.ts';
import { PublicLayout } from './components/layout';

import { Landing } from './pages/LandingPage.tsx';
import { Dashboard } from './pages/Dashboard.tsx';
import { Login } from './pages/Login.tsx';
import { McpLogin } from './pages/McpLogin.tsx.tsx';
import { ProjectView } from './pages/ProjectView.tsx';
import { EntryDetail } from './pages/EntryDetail.tsx';
import { Settings } from './pages/Settings.tsx';
import { Analytics } from './pages/Analytics.tsx';
import { NotFound } from './pages/NotFound.tsx';
import { LoadingScreen } from './components/LoadingScreen.tsx';
import { Strategy } from './pages/Strategy.tsx';
import { Content } from './pages/Content';

// NEW: Import the ThemeProvider
import { ThemeProvider } from './contexts/ThemeContext';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, u => { setUser(u); setLoading(false); });
    return unsub;
  }, []);
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, u => { setUser(u); setLoading(false); });
    return unsub;
  }, []);
  if (loading) return <LoadingScreen />;
  if (user) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    // NEW: Wrap the entire app in the ThemeProvider
    <ThemeProvider>
      <Routes>
        {/* Public landing — wrapped in pill header + footer */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <PublicLayout>
                <Landing />
              </PublicLayout>
            </PublicRoute>
          }
        />

        {/* Auth — minimal chrome, no PublicLayout footer clutter */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        {/* MCP OAuth — no auth guard, no chrome */}
        <Route path="/mcp/login" element={<McpLogin />} />

        {/* Protected app routes */}
        <Route path="/dashboard"                          element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/projects/:projectId"                element={<ProtectedRoute><ProjectView /></ProtectedRoute>} />
        <Route path="/projects/:projectId/entry/:entryId" element={<ProtectedRoute><EntryDetail /></ProtectedRoute>} />
        <Route path="/settings"                           element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/analytics"                          element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
        <Route path="/strategy"                           element={<ProtectedRoute><Strategy /></ProtectedRoute>} />
        <Route path="/content"                            element={<ProtectedRoute><Content /></ProtectedRoute>} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </ThemeProvider>
  );
}